module.exports = __webpack_public_path__ + "static/media/armretta_small.7ad97bde.png";